import { defineStore } from 'pinia';
import { currentEnv, currentSystem } from '@/core/http/env';
import http from '@/core/http';
import { AppState } from './type';
import { useDomainConf } from '@toy/business-components';

export const useAppStore = defineStore({
  id: 'app',
  state: (): AppState => ({
    systemDomain: null,
  }),

  actions: {
    async getEnvConfig() {
      if (this.systemDomain) return;
      const { getDomainConf } = useDomainConf(currentEnv);
      const data = await getDomainConf(`${currentEnv}-${currentSystem}`);
      this.systemDomain = data;
      http.setDomain(data);
    },
  },
});
